import React from 'react';
import { Routes, Route, Link, useNavigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import CategoriesPage from './pages/CategoriesPage';
import StoresPage from './pages/StoresPage';
import VendorsPage from './pages/VendorsPage';
import AddFlyerPage from './pages/AddFlyerPage';
import FlyersListPage from './pages/FlyersListPage';
import PagesListPage from './pages/PagesListPage';
import OffersListPage from './pages/OffersListPage';
import EmployeeDashboardPage from './pages/EmployeeDashboardPage';
import ActivityLogPage from './pages/ActivityLogPage';

function AppNav() {
  const { user, isAdmin, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  if (!user) return null;

  return (
    <nav className="bg-gray-800 text-white p-4 flex items-center justify-between">
      <div className="flex items-center gap-4">
        <Link to="/dashboard" className="hover:text-gray-300">Dashboard</Link>
        <Link to="/categories" className="hover:text-gray-300">Categories</Link>
        <Link to="/stores" className="hover:text-gray-300">Stores</Link>
        <Link to="/vendors" className="hover:text-gray-300">Vendors</Link>
        <Link to="/add-flyer" className="hover:text-gray-300">Add Flyer</Link>
        {isAdmin && <Link to="/employees" className="hover:text-gray-300">Employees</Link>}
        {isAdmin && <Link to="/activity-log" className="hover:text-gray-300">Activity Log</Link>}
      </div>
      <div className="flex items-center gap-4">
        <span className="text-sm text-gray-300">
          {user.name} <span className="text-xs text-gray-500">({user.role})</span>
        </span>
        <button
          onClick={handleLogout}
          className="text-sm bg-red-600 hover:bg-red-700 px-3 py-1 rounded"
        >
          Logout
        </button>
      </div>
    </nav>
  );
}

export default function App() {
  return (
    <div>
      <AppNav />
      <main className="p-8">
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          <Route path="/" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/categories" element={<ProtectedRoute><CategoriesPage /></ProtectedRoute>} />
          <Route path="/stores" element={<ProtectedRoute><StoresPage /></ProtectedRoute>} />
          <Route path="/vendors" element={<ProtectedRoute><VendorsPage /></ProtectedRoute>} />
          <Route path="/add-flyer" element={<ProtectedRoute><AddFlyerPage /></ProtectedRoute>} />
          <Route path="/stores/:storeId/flyers" element={<ProtectedRoute><FlyersListPage /></ProtectedRoute>} />
          <Route path="/flyers/:flyerId/pages" element={<ProtectedRoute><PagesListPage /></ProtectedRoute>} />
          <Route path="/vendors/:vendorId/offers" element={<ProtectedRoute><OffersListPage /></ProtectedRoute>} />
          <Route path="/categories/:categoryId/offers" element={<ProtectedRoute><OffersListPage /></ProtectedRoute>} />
          <Route path="/pages/:pageId/offers" element={<ProtectedRoute><OffersListPage /></ProtectedRoute>} />

          {/* Admin only */}
          <Route path="/employees" element={<ProtectedRoute adminOnly><EmployeeDashboardPage /></ProtectedRoute>} />
          <Route path="/activity-log" element={<ProtectedRoute adminOnly><ActivityLogPage /></ProtectedRoute>} />
        </Routes>
      </main>
    </div>
  );
}
